import { useLoggedOutSuppliersPageCurrentCategory } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/Context/useLoggedOutSuppliersPageCurrentCategory";
import { useLoggedOutSuppliersPageMetaTagsRelatedCategoriesHeader } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/LoggedOutSuppliersPageMetaTags/useLoggedOutSuppliersPageMetaTagsRelatedCategoriesHeader";
import { LoggedOutSuppliersPageHeaderCategoryCarousel } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageHeader/__internal__/LoggedOutSuppliersPageHeaderCategoryCarousel";
import { Spacer } from "@faire/web/slate/spacing";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";

export const MaybeLoggedOutSuppliersPageMwebCategoryCarousel: React.FC = () => {
  const title = useLoggedOutSuppliersPageMetaTagsRelatedCategoriesHeader();

  const categoryModel = useLoggedOutSuppliersPageCurrentCategory();
  const { mostSpecificPathIdentifier } = categoryModel;
  const { isTabletAndBelow } = useViewport();
  if (!isTabletAndBelow) {
    return null;
  }

  return (
    <>
      <Spacer height="1x" />
      <LoggedOutSuppliersPageHeaderCategoryCarousel
        title={title}
        categoryPathIdentifier={mostSpecificPathIdentifier}
        className="pb-6 pl-4"
      />
    </>
  );
};
